import React, { useEffect, useState } from "react";
import { Button, Form, Icon, Popup } from "semantic-ui-react";
import NumericInput from "../../../components/shared/NumericInput";
import PropTypes from "prop-types";
import Panel from "../../../components/shared/Panel";
import { useTextResources } from "../../../language";
import { DiscountTypesEnum, maxNumericInputValue } from "../../../components/shared/constants";

export const ExtraPersonPriceEdit = ({ onChange = () => { }, designationIds, getPriceByDesignationId, discountType, nullable, isDerived, ...formFieldExtraProps }) => {
    const text = useTextResources();
    const [maxInput, setMaxInput] = useState(DiscountTypesEnum.Amount);

    useEffect(() => {
        setMaxInput(discountType == DiscountTypesEnum.Percent ? 100 : maxNumericInputValue);
    }, [discountType]);

    const firstPrice = getPriceByDesignationId(designationIds[0]);
    const secondPrice = getPriceByDesignationId(designationIds[1]);
    const thirdPrice = getPriceByDesignationId(designationIds[2]);
    const fourthPrice = getPriceByDesignationId(designationIds[3]);
    const isPriceSet = nullable ?
        (
            Number.isFinite(firstPrice) ||
            Number.isFinite(secondPrice) ||
            Number.isFinite(thirdPrice) ||
            Number.isFinite(fourthPrice)
        ) :
        (firstPrice || secondPrice || thirdPrice || fourthPrice);

    return (
        <Popup
            position="bottom left"
            basic
            openOnTriggerClick
            content={
                <Panel>
                    <Form.Field
                        control={NumericInput}
                        selectOnFocus
                        onChangeComplete={(value) => onChange(designationIds[0], value)}
                        value={firstPrice}
                        buttonPlacement="none"
                        label={text("First")}
                        max={maxInput}
                        nullable
                        {...formFieldExtraProps}
                        disabled={isDerived}
                    />
                    <Form.Field
                        control={NumericInput}
                        selectOnFocus
                        onChangeComplete={(value) => onChange(designationIds[1], value)}
                        value={secondPrice}
                        buttonPlacement="none"
                        label={text("Second")}
                        max={maxInput}
                        nullable
                        {...formFieldExtraProps}
                        disabled={isDerived}
                    />
                    <Form.Field
                        control={NumericInput}
                        selectOnFocus
                        onChangeComplete={(value) => onChange(designationIds[2], value)}
                        value={thirdPrice}
                        buttonPlacement="none"
                        label={text("Third")}
                        max={maxInput}
                        nullable
                        {...formFieldExtraProps}
                        disabled={isDerived}
                    />
                    <Form.Field
                        control={NumericInput}
                        selectOnFocus
                        onChangeComplete={(value) => onChange(designationIds[3], value)}
                        value={fourthPrice}
                        buttonPlacement="none"
                        label={text("Fourth")}
                        max={maxInput}
                        nullable
                        {...formFieldExtraProps}
                        disabled={isDerived}
                    />
                </Panel>
            }
            on="click"
            trigger={<Button type="button" className={isPriceSet ? "price-set" : ""} fluid icon basic labelPosition="right" style={{ textAlign: "start", height: 38 }}>
                <Icon name="triangle down" />{text("Edit")}</Button>}>
        </Popup>
    );
};

ExtraPersonPriceEdit.propTypes = {
    onChange: PropTypes.func,
    designationIds: PropTypes.array,
    discountType: PropTypes.any,
    getPriceByDesignationId: PropTypes.func,
    nullable: PropTypes.bool,
    formFieldExtraProps: PropTypes.object,
    isDerived: PropTypes.bool
};
